export const TabKeyEnum = {
  RESTORED_ALARM: '0',
  UNRESTORED_ALARM: '1',
};
export const TabKeyStateDisplay = {
  [TabKeyEnum.RESTORED_ALARM]: '已恢复',
  [TabKeyEnum.UNRESTORED_ALARM]: '未恢复',
};
export const AlarmLevel = {
  ALL: 5,
  HIGHEST: 0,
  HIGH: 1,
  MIDDLE: 2,
  LOW: 3,
  LOWEST: 4,
};

export const AlarmLevelDisplay = {
  [AlarmLevel.ALL]: '全部',
  [AlarmLevel.HIGHEST]: '最高级',
  [AlarmLevel.HIGH]: '高级',
  [AlarmLevel.MIDDLE]: '中级',
  [AlarmLevel.LOW]: '低级',
  [AlarmLevel.LOWEST]: '最低级',
};

export const AlarmLevelColorDisplay = {
  [AlarmLevel.HIGHEST]: '#FF3141',
  [AlarmLevel.HIGH]: '#FF9F18',
};
